import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const BannerForm = ({ show, handleClose, handleSubmit, banner, errors }) => {
    const [formData, setFormData] = useState({
        link_type: "",
        link: "",
        image: null,
    });

    const linkOptions = [
        { value: "ext_link", label: "External Link" },
        { value: "business_link", label: "Business Link" },
        { value: "subplan_link", label: "Subplan Link" },
    ];

    useEffect(() => {
        if (banner) {
            setFormData({
                link_type: banner.link_type || "",
                link: banner.link || "",
                image: null,
            });
        } else {
            setFormData({ link_type: "", link: "", image: null });
        }
    }, [banner, show]);

    const handleSelectChange = (selectedOption) => {
        setFormData({ ...formData, link_type: selectedOption ? selectedOption.value : "" });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit(formData);
    };

    const renderError = (field) => {
        if (errors && errors[field]) {
            return (
                <div className="text-danger mt-1" style={{ fontSize: '12px', fontWeight: '500' }}>
                    {Array.isArray(errors[field]) ? errors[field][0] : errors[field]}
                </div>
            );
        }
        return null;
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{banner ? "Edit Banner" : "Add New Banner"}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={onSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Link Type</Form.Label>
                        <Select
                            options={linkOptions}
                            value={linkOptions.find(opt => opt.value === formData.link_type)}
                            onChange={handleSelectChange}
                            placeholder="Select Link Type"
                            isClearable
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderColor: errors?.link_type ? '#dc3545' : base.borderColor,
                                    '&:hover': { borderColor: errors?.link_type ? '#dc3545' : base.borderColor }
                                })
                            }}
                        />
                        {renderError("link_type")}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Link Value</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.link}
                            isInvalid={!!errors?.link}
                            onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                            placeholder="Enter external link or ID"
                        />
                        {renderError("link")}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Banner Image</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            isInvalid={!!errors?.image}
                            onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
                        />
                        {renderError("image")}
                        {banner?.image && !formData.image && (
                            <div className="mt-2">
                                <small className="text-muted">Current image exists</small>
                            </div>
                        )}
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                    <Button variant="primary" type="submit">
                        {banner ? "Update Banner" : "Save Banner"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default BannerForm;